module.exports = __webpack_public_path__ + "img/cmp-regenerate-inactive.ac62a1fc.svg";